<style scoped="scoped" lang="scss">
.mould-no {
  width: 250px;
  max-height: 100px;
  overflow: auto;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mold/outbound/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujuchukudanhao')">
            <el-input v-model="yt.conditions.moldOutboundNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianhao(jingzhun)')">
            <el-input v-model="yt.conditions.noEqual"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_data_select multiple type="mould" :ids.sync="yt.conditions.moldIdList"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('chukuleixing')">
            <yi_dictionary_select :max="999" clearable type="MOULD_OUTBOUND_TYPE" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select :max="999" clearable type="MOULD_IN_ORDER_STATUS" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_mold_management_mold_outbound_batchCreate')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具出库单-新增' } }">
          {{ $t('xinzeng') }}
        </el-button>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng(stlt)', null, 'w1')" type="primary" v-if="utils.checkPower('web_mold_management_mold_outbound_create_stlt')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具出库单-新增(赛特莱特)' } }">
          {{ $t('xinzeng(stlt)') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="scope.row.status === '1' && utils.checkPower('web_mold_management_mold_outbound_outbound_comfirm')" :loading="scope.row.reviewLoading" @click="outboundComfirm(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具出库单-审核' } }">
              {{ $t('chukuqueren') }}
            </el-button>
            <el-button type="text" v-if="scope.row.status === '1' && utils.checkPower('web_mold_management_mold_outbound_audit') && !utils.checkPower('web_mold_management_mold_outbound_outbound_comfirm')" :loading="scope.row.reviewLoading" @click="review(scope.row)" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '模具出库单-审核' } }">
              {{ $t('shenhe') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="scope.row.status === '1' && utils.checkPower('web_mold_management_mold_outbound_update')" @click="yt.showEditDialog('bianji', scope.row, '35%')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="scope.row.status === '1' && utils.checkPower('web_mold_management_mold_outbound_delete')" @click="yt.remove(scope.row, '/web/mold/outbound/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @closed="onClose()">
      <!-- 新增弹窗-->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_OUTBOUND_TYPE" :ids.sync="yt.editObj.type" @change="typeChange"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gongsi')" v-if="!companyRequired">
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongsi')" v-if="companyRequired" required>
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujichukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedOutboundTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select ref="mould" multiple type="mould" :ids.sync="yt.editObj.moldIdList" @change="mouldChange"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yixuanzemojubianhao') + ':'">
            <div class="mould-no">{{ yt.editObj.mouldNos }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="mini"
            @click="
              yt.isShowEditDialog = false;
              companyRequired = false;
            "
            >{{ $t('quxiao') }}</el-button
          >
          <el-button :loading="yt.editObj.loading" size="mini" @click="insertSave()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 新增弹窗（赛特莱特）-->
      <template v-if="yt.editObj.action == 'xinzeng(stlt)'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_OUTBOUND_TYPE" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shijichukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.actualOutboundTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('gongsi')" required>
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujifachushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedSendTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('yujichukushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedOutboundTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujubianma/mingcheng')" required>
            <yi_data_select ref="mould" multiple type="mould" :ids.sync="yt.editObj.moldIdList" @change="mouldChange"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yixuanzemojubianhao') + ':'">
            <div class="mould-no">{{ yt.editObj.mouldNos }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="insertSaveStlt()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗-->
      <template v-if="yt.editObj.action == 'bianji' && !utils.checkPower('web_mold_management_mold_outbound_create_stlt')">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_OUTBOUND_TYPE" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('yujichukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedOutboundTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('gongsi')">
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select disabled :component="'web_base_mould_list'" :ids.sync="yt.editObj.moldId"> </yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="updateSave()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 编辑弹窗(赛特莱特)-->
      <template v-if="yt.editObj.action == 'bianji' && utils.checkPower('web_mold_management_mold_outbound_create_stlt')">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chukuleixing')" required>
            <yi_dictionary_select :max="999" clearable type="MOULD_OUTBOUND_TYPE" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shijichukushijian')" required>
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.actualOutboundTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('gongsi')" required>
            <el-input v-model="yt.editObj.company" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lianxidizhi')">
            <el-input v-model="yt.editObj.address" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yujifachushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedSendTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('yujichukushijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.editObj.estimatedOutboundTime"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark" :rows="4" :max="200"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select disabled :component="'web_base_mould_list'" :ids.sync="yt.editObj.moldId"> </yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="updateSaveStlt()" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import XLSX from 'xlsx';

export default {
  name: 'web_mold_management_mold_outbound_list',
  data() {
    return {
      exportLoading: false,
      selectRows: [],
      companyRequired: false,
      columns: [
        {
          label: 'mujuchukudanhao',
          prop: 'moldOutboundNumber'
        },
        {
          label: 'mujubianhao',
          prop: 'mold.no'
        },
        {
          label: 'mujubianma',
          prop: 'mold.code'
        },
        {
          label: 'mujumingcheng',
          prop: 'mold.name'
        },
        {
          label: 'chukuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'MOULD_OUTBOUND_TYPE'
        },
        {
          label: 'gongsi',
          prop: 'company'
        },
        {
          label: 'lianxidizhi',
          prop: 'address',
          width: 150
        },
        {
          label: 'yujichukushijian',
          prop: 'estimatedOutboundTime',
          type: 'time',
          width: 230
        },
        {
          label: 'cangkubianma',
          prop: 'warehouse.code'
        },
        {
          label: 'cangkumingcheng',
          prop: 'warehouse.name'
        },
        {
          label: 'kuqubianma',
          prop: 'warehouseArea.code'
        },
        {
          label: 'kuqumingcheng',
          prop: 'warehouseArea.name'
        },
        {
          label: 'kuweibianma',
          prop: 'warehouseLocation.code'
        },
        {
          label: 'kuweimingcheng',
          prop: 'warehouseLocation.name'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150
        },
        {
          label: 'suoshuchejian',
          prop: 'orgName'
        },
        {
          label: 'chanpinbianma',
          prop: 'materialCode'
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName'
        },
        {
          label: 'chanpinmiaoshu',
          prop: 'materialDescribe'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName'
        },
        {
          label: 'mujubaoyangdanhao',
          prop: 'maintain.no',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'danjuzhuangtai',
          type: 'tag',
          prop: 'status',
          tags: {
            '1': {
              color: '#ff7a45',
              text: this.$t('daichuli')
            },
            '2': {
              color: '#9254de',
              text: this.$t('yishenhe')
            }
          }
        },
        {
          label: 'shenheren',
          prop: 'reviewByObject.nickname'
        },
        {
          label: 'shenheshijian',
          prop: 'reviewTime',
          type: 'time',
          width: 160
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 160
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 160,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    mouldChange(moldIdList) {
      if (!moldIdList) {
        return;
      }
      const items = this.$refs['mould'].items;
      const map = items.reduce((map, item) => {
        map.set(item.id, item);
        return map;
      }, new Map());
      let rows = [];
      for (let i = 0; i < moldIdList.length; i++) {
        const moldId = moldIdList[i];
        rows.push(map.get(moldId));
      }

      const mouldNos = rows.map(row => row.no);
      this.yt.editObj.mouldNos = mouldNos.join('、');
      this.selectRows = rows;
    },
    // 保存新增
    insertSaveStlt() {
      if (this.yt.editObj.company === undefined || this.yt.editObj.company === '') {
        return this.$message.error(this.$t('gongsi') + this.$t('bunengweikong'));
      }
      // 筛选出不是[在库未用]状态的模具编号
      const mouldNos = this.selectRows.filter(row => row.status !== '1').map(row => row.no);
      if (mouldNos && mouldNos.length > 0) {
        const nos = mouldNos.join(',');
        return this.$message.error(this.$t('mojubianhao') + nos + this.$t('bushizaikuweiyongzhuangtai'));
      }
      // this.yt.req('POST', '/web/mold/outbound/batchCreate');
      this.http
        .post('web/mold/outbound/batchCreate', this.yt.editObj)
        .then(res => {
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
        })
        .catch(err => {
          let msg = err.replace('未知异常：', '');
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'error',
            message: '错误：<br/>' + msg
          });
        });
    },
    // 保存新增
    insertSave() {
      // 筛选出不是[在库未用]状态的模具编号
      const mouldNos = this.selectRows.filter(row => row.status !== '1').map(row => row.no);
      if (mouldNos && mouldNos.length > 0) {
        const nos = mouldNos.join(',');
        return this.$message.error(this.$t('mojubianhao') + nos + this.$t('bushizaikuweiyongzhuangtai'));
      }
      // this.yt.req('POST', '/web/mold/outbound/batchCreate');
      this.http
        .post('web/mold/outbound/batchCreate', this.yt.editObj)
        .then(res => {
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
        })
        .catch(err => {
          let msg = err.replace('未知异常：', '');
          this.$message({
            dangerouslyUseHTMLString: true,
            type: 'error',
            message: '错误：<br/>' + msg
          });
        });
      this.companyRequired = false;
    },
    // 保存编辑
    updateSave() {
      this.yt.req('POST', '/web/mold/outbound/update');
    },
    // 保存编辑
    updateSaveStlt() {
      if (this.yt.editObj.company === undefined || this.yt.editObj.company === '') {
        return this.$message.error(this.$t('gongsi') + this.$t('bunengweikong'));
      }
      this.yt.req('POST', '/web/mold/outbound/update');
    },
    // 审核
    review(row) {
      this.$set(row, 'reviewLoading', true);
      this.http
        .post('/web/mold/outbound/audit', [row])
        .then(res => {
          if (res.data) {
            this.yt.get(1);
            row.status = '2';
            this.$message.success(this.$t('shenhechenggong'));
          } else {
            this.$message.error(this.$t('shenheshibai'));
          }
        })
        .catch(err => {
          this.$message.error(err);
        })
        .finally(() => {
          this.$set(row, 'reviewLoading', false);
        });
    },
    //出库确认
    outboundComfirm(row){
      this.$set(row, 'reviewLoading', true);
      this.http.post('/web/mold/outbound/outboundComfirm', [row]).then(res => {
        if (res.data) {
          this.yt.get(1);
          this.$message.success(this.$t('chenggong'));
        }
      })
      .catch(err => {
        this.$message.error(err);
      })
      .finally(() => {
        this.$set(row, 'reviewLoading', false);
      });
    },
    typeChange(e) {
      if (e == 1 || e == 2) {
        this.companyRequired = true;
        this.yt.editObj.loading = true;
        this.http
          .post('/web/mold/outbound/getLatestOutbound', { type: e })
          .then(res => {
            if (res.data) {
              this.$set(this.yt.editObj, 'company', res.data.company);
            }
          })
          .catch(error => {
            this.$message.error(error);
          })
          .finally(() => {
            this.yt.editObj.loading = false;
          });
      } else {
        this.companyRequired = false;
      }
    },
    onClose() {
      this.selectRows = [];
    },
    //导出
    // exportExcel() {
    //   let params = this.yt.conditions;
    //   params.createTimeStart = this.yt.conditions.startTime;
    //   params.createTimeEnd = this.yt.conditions.endTime;
    //   return this.http
    //     .get('/web/report/export/mould_outbound_export', { params })
    //     .then(res => {
    //       this.$message.success(this.$t(res.msg));
    //       this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
    //     })
    //     .catch(error => {
    //       this.$message.error(this.$t(error));
    //     });
    // },
    exportExcel() {
      this.http.get('web/mold/outbound/page?page=1&pageSize=10000', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => {
          if (i.label != 'caozuo') {
            return this.$t(i.label);
          }
        });
        let filterFirst = tableFirst.filter(item => {
          if (item) {
            return item;
          }
        });
        let tableData = [];
        tableData.push(filterFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i], filterFirst);
          tableData.push(dataArr);
        }
        console.log('tableArr', tableData);
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `模具出库单-${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      });
    },
    getTableDataArr(row, tableFirst) {
      console.log(row);
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('mujuchukudanhao'))] = row.moldOutboundNumber;
      dataArr[tableFirst.indexOf(this.$t('mujubianhao'))] = row.mold && row.mold.no;
      dataArr[tableFirst.indexOf(this.$t('mujubianma'))] = row.mold && row.mold.code;
      dataArr[tableFirst.indexOf(this.$t('mujumingcheng'))] = row.mold && row.mold.name;
      console.log(row.type);
      if (row.type != null) {
        switch (row.type) {
          case '1':
            dataArr[tableFirst.indexOf(this.$t('chukuleixing'))] = this.$t('outgoing_repairs_out_warehouse');
            break;
          case '2':
            dataArr[tableFirst.indexOf(this.$t('chukuleixing'))] = this.$t('outbound_production_out_warehouse');
            break;
          case '3':
            dataArr[tableFirst.indexOf(this.$t('chukuleixing'))] = this.$t('gongdanshengchanchuku');
            break;
          case '4':
            dataArr[tableFirst.indexOf(this.$t('chukuleixing'))] = this.$t('outbound_prepare_work');
            break;
          default:
            dataArr[tableFirst.indexOf(this.$t('chukuleixing'))] = '';
            break;
        }
      }
      dataArr[tableFirst.indexOf(this.$t('gongsi'))] = row.company;
      dataArr[tableFirst.indexOf(this.$t('lianxidizhi'))] = row.address;
      dataArr[tableFirst.indexOf(this.$t('yujichukushijian'))] = row.estimatedOutboundTime && this.dayjs(row.estimatedOutboundTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[tableFirst.indexOf(this.$t('cangkubianma'))] = row.warehouse && row.warehouse.code;
      dataArr[tableFirst.indexOf(this.$t('cangkumingcheng'))] = row.warehouse && row.warehouse.name;
      dataArr[tableFirst.indexOf(this.$t('kuqubianma'))] = row.warehouseArea && row.warehouseArea.code;
      dataArr[tableFirst.indexOf(this.$t('kuqumingcheng'))] = row.warehouseArea && row.warehouseArea.name;
      dataArr[tableFirst.indexOf(this.$t('kuweibianma'))] = row.warehouseLocation && row.warehouseLocation.code;
      dataArr[tableFirst.indexOf(this.$t('kuweimingcheng'))] = row.warehouseLocation && row.warehouseLocation.name;
      dataArr[tableFirst.indexOf(this.$t('mujubaoyangdanhao'))] = row.maintain && row.maintain.no;
      dataArr[tableFirst.indexOf(this.$t('beizhu'))] = row.remark;
      if (row.status != null) {
        switch (row.status) {
          case '1':
            dataArr[tableFirst.indexOf(this.$t('danjuzhuangtai'))] = this.$t('daichuli');
            break;
          case '2':
            dataArr[tableFirst.indexOf(this.$t('danjuzhuangtai'))] = this.$t('yishenhe');
            break;
        }
      } else {
        dataArr[tableFirst.indexOf(this.$t('danjuzhuangtai'))] = '';
      }
      dataArr[tableFirst.indexOf(this.$t('shenheren'))] = row.reviewByObject && row.reviewByObject.nickname;
      dataArr[tableFirst.indexOf(this.$t('shenheshijian'))] = row.reviewTime && this.dayjs(row.reviewTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[tableFirst.indexOf(this.$t('chuangjianren'))] = row.createByObject && row.createByObject.nickname;
      dataArr[tableFirst.indexOf(this.$t('chuangjianshijian'))] = row.createTime && this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss');

      if (row.actualOutboundTime != null) {
        dataArr[tableFirst.indexOf(this.$t('shijichukushijian'))] = row.actualOutboundTime && this.dayjs(row.actualOutboundTime).format('YYYY-MM-DD HH:mm:ss');
      } else {
        dataArr[tableFirst.indexOf(this.$t('shijichukushijian'))] = '';
      }
      if (row.estimatedSendTime != null) {
        dataArr[tableFirst.indexOf(this.$t('yujifachushijian'))] = row.estimatedSendTime && this.dayjs(row.estimatedSendTime).format('YYYY-MM-DD HH:mm:ss');
      } else {
        dataArr[tableFirst.indexOf(this.$t('yujifachushijian'))] = '';
      }
      return dataArr;
    }
  }
};
</script>
